import React, { useEffect, useState } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";
import RangeAuditTable from "./RangeAuditTable";
import { fetchWithToken } from "../../../../apiUtils";

const useStyles = makeStyles({
  table: {
    marginTop: 45,
  },
  loading: {
    marginTop: "25%",
    marginLeft: "50%",
  },
});

const RangeAudit = () => {
  const classes = useStyles();

  const [dataObj, setDataObj] = useState({
    rangeAudits: [],
    loading: true,
  });

  useEffect(() => {
    fetchWithToken("api/RangeAudit/")
      .then((response) => response.json())
      .then((data) =>
        setDataObj({
          rangeAudits: data,
          loading: false,
        })
      );
  }, []);

  return (
    <>
      {dataObj.loading ? (
        <CircularProgress className={classes.loading} />
      ) : (
        <div className={classes.table}>
          <RangeAuditTable data={dataObj.rangeAudits} />
        </div>
      )}
    </>
  );
};
export default RangeAudit;
